import { UserRoleDTO } from '@services/DTO/UserDTO'

export class CreateUserRequestDTO {

    constructor(
        public name: string,
        public emailAddress?: string,
        public role?: UserRoleDTO,
        public password?: string,
    ) { }
}
